export const environment = {
  properties: {
    analytics: {
      tagManagerContainerId: 'GTM-PZNCSJK',
    },
    app: {
      environmentLabel: 'Development',
      developmentFeatureRoutesEnabled: true,
      featureFlags: {},
      externalUrls: {
        iwaContactUrl: 'https://pennstate.service-now.com/sp?id=sc_category&sys_id=3085d7780f781b802c4900dce1050ecc',
      },
    },
    cdn: {
      baseUrl: 'https://static.apps.psu.edu/',
    },
    fortress: {
      url: 'https://develop-fortress-service.qa.k8s.psu.edu/fortress-service-web/resources/',
    },
    groupService: {
      url: 'https://develop-group-service.qa.k8s.psu.edu/',
    },
    iwah: {
      url: 'https://develop-iwah-service.qa.k8s.psu.edu/',
    },
    oauth: {
      clientId: '48b4d6fa-620d-4fe3-8979-828d8c73d133',
      discoveryDocumentUrl: 'https://develop-hydra-auth-server.qa.k8s.psu.edu/.well-known/openid-configuration',
      issuer: 'https://develop-oauth2-server.qa.k8s.psu.edu/',
      preserveRequestedRoute: true,
      redirectUri: 'https://iwa-hub.development.apps.psu.edu',
      responseType: 'code',
      scope: 'openid offline_access',
      showDebugInformation: true,
      strictDiscoveryDocumentValidation: false,
    },
    search: {
      url: 'https://develop-search-service.qa.k8s.psu.edu/search-service/resources/',
    },
  },
};
